import { cloneDeep } from 'lodash';
import React, { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AnalyticsContext = /*#__PURE__*/React.createContext(null);
AnalyticsContext.displayName = 'AnalyticsContext';
export const AnalyticsProvider = _ref => {
  let {
    children
  } = _ref;
  const analytics = useMemo(() => {
    const handlers = [];
    return {
      setUserId(userId) {
        for (const handler of handlers) {
          try {
            var _handler$setUserId;
            (_handler$setUserId = handler.setUserId) === null || _handler$setUserId === void 0 || _handler$setUserId.call(handler, userId);
          } catch (e) {
            console.error(e);
          }
        }
      },
      trackEvent(event) {
        for (const handler of handlers) {
          try {
            var _handler$trackEvent;
            (_handler$trackEvent = handler.trackEvent) === null || _handler$trackEvent === void 0 || _handler$trackEvent.call(handler, cloneDeep(event));
          } catch (e) {
            console.error(e);
          }
        }
      },
      trackPage() {
        for (const handler of handlers) {
          try {
            var _handler$trackPage;
            (_handler$trackPage = handler.trackPage) === null || _handler$trackPage === void 0 || _handler$trackPage.call(handler);
          } catch (e) {
            console.error(e);
          }
        }
      },
      addHandler(handler) {
        handlers.push(handler);
      },
      removeHandler(handler) {
        const index = handlers.indexOf(handler);
        if (index >= 0) {
          handlers.splice(index, 1);
          return true;
        }
        return false;
      }
    };
  }, []);
  return /*#__PURE__*/_jsx(AnalyticsContext.Provider, {
    value: analytics,
    children: children
  });
};
export const useAnalytics = () => {
  const context = React.useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics() must be used within an <AnalyticsProvider />');
  }
  return context;
};